<template>
  <v-navigation-drawer
    fixed
    right
    temporary
    :value="opened"
    width="600px"
    @input="onInput"
  >
    <template v-slot:prepend>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold mb-2"
              >SRS Code Change Logs</v-list-item-title
            >
            <v-list-item-subtitle>
              <span>{{ codeSnapshot }}</span>
              <v-icon class="mx-2" small>mdi-arrow-right</v-icon>
              <span>{{ codeChange }}</span>
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon @click="onCloseClicked">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
    </template>
    <v-list dense class="mt-0 pt-0">
      <template v-for="(log, index) in logs">
        <v-list-item :key="'log-' + index">
          <v-list-item-icon class="mr-4">
            <v-icon :color="getIconColor(log.logLevel)">
              {{ getIcon(log.logLevel) }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle>{{
              getDateFormatted(log.dateCreated)
            }}</v-list-item-subtitle>
            <v-list-item-title class="text-wrap">{{
              log.message
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider :key="'divider-' + index" />
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import dates from "../utils/dates";
export default {
  props: {
    codeSnapshot: {
      type: String,
      required: true,
    },
    codeChange: {
      type: String,
      required: true,
    },
    opened: {
      type: Boolean,
      required: false,
      default: false,
    },
    logs: {
      type: Array,
      required: false,
      default: () => [],
    },
  }, // props
  methods: {
    onCloseClicked() {
      this.$emit("closed");
    },
    onInput($event) {
      if ($event == false) this.$emit("closed");
    },
    getDateFormatted(date) {
      return dates.MMDDYYYYHHmmss(date);
    },
    getIcon(logLevel) {
      if (logLevel == "Information") return "mdi-information-outline";
      if (logLevel == "Error") return "mdi-alert-octagram-outline";
      if (logLevel == "Warning") return "mdi-alert-outline";
      if (logLevel == "Success") return "mdi-check-circle";
      return undefined;
    },
    getIconColor(logLevel) {
      if (logLevel == "Information") return "primary";
      if (logLevel == "Error") return "error";
      if (logLevel == "Warning") return "warning";
      if (logLevel == "Success") return "success";
      return undefined;
    },
  }, // methods
};
</script>

<style>
</style>
